<template>
  <div class="preview-parts-container-image-card">
    <!-- 縦レイアウト -->
    <template v-if="partsContainer.layout_type === 'vertical'">
      <td :style="partWidth">
        <table
          border="0"
          cellpadding="0"
          cellspacing="0"
          style="width: 100%;"
        >
          <tbody>
            <tr>
              <!-- パーツコンテナ外側 -->
              <td :style="wrapperStyle">
                <!-- パーツコンテナ全体の背景色をつける -->
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  style="width: 100%;"
                  :style="innerStyle"
                >
                  <tbody>
                    <tr>
                      <td style="width: 100%;">
                        <table
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          style="width: 100%;"
                        >
                          <tbody>
                            <!-- table_countの数だけ、tr要素を作る -->
                            <tr
                              v-for="table_count in partsContainer.table_count"
                              :key="table_count"
                            >
                              <!-- table_countのループ数と、table_idが一致するものをループして、td要素を作る -->
                              <td
                                v-for="partsContainerPart in partsContainerParts(table_count)"
                                :key="partsContainerPart.order_id"
                                :style="verticalAlignStyle"
                              >
                                <!-- パーツ個別の表示 -->
                                <table
                                  style="width: 100%;"
                                  is="preview-part"
                                  :part="partsContainerPart"
                                  :partsContainerId="partsContainer.id"
                                  :sectionId="sectionId"
                                  :columnCount="partsContainer.column_count"
                                  :partWidth="partWidth"
                                  :partsContainerType="partsContainer.type"
                                  :partsContainerLayoutType="partsContainer.layout_type"
                                  :partsContainerStyles="partsContainer.styles"
                                  :partsContainerShareText="partsContainer.share_text"
                                  :horizontalDisplayRatio="partsContainer.horizontal_display_ratio"
                                  class="partsContainer, partsContainerDefault"
                                >
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </template>
    <!-- 横レイアウト -->
    <template v-else-if="partsContainer.layout_type === 'horizontal'">
      <td :style="defaultWidth">
        <table
          border="0"
          cellpadding="0"
          cellspacing="0"
          style="width: 100%;"
        >
          <tbody>
            <tr>
              <!-- パーツコンテナ外側 -->
              <td :style="wrapperStyle">
                <!-- パーツコンテナ全体の背景色をつける -->
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  style="width: 100%;"
                  :style="innerStyle"
                >
                  <tbody>
                    <tr>
                      <!-- table_countの数だけ、td要素を作る -->
                      <td
                        v-for="table_count in partsContainer.table_count"
                        :key="table_count"
                        :style="[partWidth, verticalAlignStyle]"
                      >
                        <!-- table_countのループ数と、table_idが一致するものをループして、テーブルを作る -->
                        <table
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          v-for="partsContainerPart in partsContainerParts(table_count)"
                          :key="partsContainerPart.order_id"
                          style="width: 100%;"
                        >
                          <tbody>
                            <tr>
                              <td>
                                <!-- パーツ個別の表示 -->
                                <table
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  is="preview-part"
                                  style="width: 100%;"
                                  :part="partsContainerPart"
                                  :partsContainerId="partsContainer.id"
                                  :sectionId="sectionId"
                                  :columnCount="partsContainer.column_count"
                                  :partWidth="horizontalPartWidth(partsContainer.horizontal_display_ratio, partsContainerPart)"
                                  :partsContainerType="partsContainer.type"
                                  :partsContainerLayoutType="partsContainer.layout_type"
                                  :partsContainerStyles="partsContainer.styles"
                                  :partsContainerShareText="partsContainer.share_text"
                                  :horizontalDisplayRatio="partsContainer.horizontal_display_ratio"
                                  class="partsContainer, partsContainerDefault"
                                >
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </template>
  </div>
</template>

<script>
import PreviewPart from '@/components/Content/Preview/PreviewPart'

export default {
  props: [
    'partsContainer',
    'sectionId',
    'partWidth',
    'defaultWidth',
  ],
  components: {
    PreviewPart,
  },
  computed: {
    // パーツコンテナのスタイル（外側）
    wrapperStyle () {
      if (!this.partsContainer) return null
      return {
        'padding-top': this.partsContainer.styles['padding-top'],
        'padding-right': this.partsContainer.styles['padding-right'],
        'padding-bottom': this.partsContainer.styles['padding-bottom'],
        'padding-left': this.partsContainer.styles['padding-left'],
      }
    },
    // パーツコンテナのスタイル（内側）
    innerStyle () {
      if (!this.partsContainer) return null
      return {
        'background': this.partsContainer.styles['background'],
        'border': this.partsContainer.styles['border'],
      }
    },
    // 垂直方向位置のスタイル
    verticalAlignStyle () {
      if (!this.partsContainer) return null
      // スタイルが登録されていたらその値、なければtopを設定
      const value = this.partsContainer.styles['vertical-align'] ? this.partsContainer.styles['vertical-align'] : 'top'
      return { 'vertical-align': value }
    },
    // パーツコンテナの中身を、テーブルIDでフィルターして返す
    partsContainerParts () {
      if (!this.partsContainer) return null
      return function (tableId) {
        // 並び順を変更したら画面を再描画させるため、中身のパーツをorder_id順でソートする
        return this.partsContainer.parts.filter(part => part.table_id === tableId).sort((a, b) => {
          if (a.order_id < b.order_id) return -1
          if (a.order_id > b.order_id) return 1
          return 0
        })
      }
    },
    horizontalPartWidth: {
      cache: false,
      get () {
        return (horizontalDispayRatio, partsContainerPart) => {
          const sumWidth = Number(this.partWidth.width.replace('px', ''))
          const displayRatio = this.partsRatiofromTheWhole(horizontalDispayRatio, partsContainerPart.type)
          let returnWidth = (sumWidth * displayRatio).toFixed(3)
          return {
            'width': returnWidth + 'px'
          }
        }
      }
    },
    partsRatiofromTheWhole () {
      return (horizontalDisplayRatio, partType) => {
        switch (horizontalDisplayRatio) {
          case 'imageOneToTextOne':
            return 1 / 2
          case 'imageTwoToTextOne':
            return partType === 'Image' ? 2 / 3 : 1 / 3
          case 'imageOneToTextTwo':
            return partType === 'Image' ? 1 / 3 : 2 / 3
          case 'imageOneToTextThree':
            return partType === 'Image' ? 1 / 4 : 3 / 4
          default:
            return 1 / 2
        }
      }
    },
  }
}
</script>
